export const home = {
  // Navigation
  'nav.home': 'Home',
  'nav.spreadsheet': 'Spreadsheet Hub',
  'nav.safety': 'Safety Guide',
  'nav.about': 'About',
  'nav.contact': 'Contact',
  'nav.categories': 'Categories',
  'nav.guide': 'Buying Guide',
  'nav.search_placeholder': 'Search AllChinaBuy spreadsheets, sellers, products...',

  // Hero
  'hero.title': 'The Ultimate AllChinaBuy Spreadsheet & Buying Guide',
  'hero.subtitle': 'Find Better Products With the AllChinaBuy Spreadsheet',
  'hero.description': 'Discover useful AllChinaBuy spreadsheets, sellers, product finds, QC resources, shipping information and buying guides — organized in one fast, easy-to-use resource.',
  'hero.cta_primary': 'Explore AllChinaBuy Spreadsheet',
  'hero.cta_secondary': 'Browse Buying Guides',
  'hero.trust_badge': 'Independent resource • Updated regularly • Built for smarter product research',
  'hero.supporting': 'Whether you are looking for a specific product, comparing sellers, checking QC information or researching shipping costs, our AllChinaBuy Spreadsheet hub brings the most useful resources together.',

  // Categories
  'categories.title': 'Popular AllChinaBuy Categories',
  'categories.description': 'Browse our curated product categories and find exactly what you are looking for.',
  'categories.all': 'All Categories',

  // Category names
  'cat.shoes': 'Shoes',
  'cat.hoodies': 'Hoodies / Sweaters',
  'cat.tshirts': 'T-Shirts',
  'cat.jackets': 'Jackets',
  'cat.pants': 'Pants / Shorts',
  'cat.headwear': 'Headwear',
  'cat.sets': 'Sets',
  'cat.underwear': 'Underwear / Underpants',
  'cat.jersey': 'Jersey',
  'cat.accessories': 'Accessories',
  'cat.bags': 'Bags',
  'cat.belts': 'Belts',
  'cat.perfumes': 'Perfumes',
  'cat.other': 'Other Stuff',

  // Main website CTA buttons
  'cta.main_button': 'AllChinaBuy Spreadsheet',
  'cta.buy_now': 'Buy It Now',
  'cta.visit_main': 'Visit the Main Website',
  'cta.ready_title': 'Ready to Explore More?',
  'cta.ready_desc': 'Use our AllChinaBuy Spreadsheet resources to discover products, compare sellers and research your next purchase.',

  // Featured Articles
  'articles.title': 'Latest AllChinaBuy Guides',
  'articles.description': 'In-depth articles to help you make smarter buying decisions.',
  'articles.read_more': 'Read Full Guide',
  'articles.all_guides': 'View All Guides',

  // Article titles
  'article.complete_guide': 'AllChinaBuy Spreadsheet: Complete Guide 2026',
  'article.complete_guide_desc': 'Everything you need to know about using the AllChinaBuy Spreadsheet — from finding sellers to verifying product quality.',
  'article.is_legit': 'Is AllChinaBuy Legit? Complete Safety Guide',
  'article.is_legit_desc': 'We break down the safety, trust signals and risks of buying through AllChinaBuy. Learn how to protect yourself.',
  'article.shipping': 'AllChinaBuy Shipping Cost Guide 2026',
  'article.shipping_desc': 'Detailed breakdown of shipping methods, costs by country, and tips to save on delivery fees.',
  'article.coupon': 'AllChinaBuy Coupon & Discount Code Guide',
  'article.coupon_desc': 'How to find and use AllChinaBuy coupons, discount codes and seasonal promotions for maximum savings.',
  'article.review': 'AllChinaBuy Review: Features & Buying Experience',
  'article.review_desc': 'An honest, independent review of the AllChinaBuy platform covering search, ordering, QC and shipping.',
  'article.qc': 'AllChinaBuy QC Photos Guide: What to Look For',
  'article.qc_desc': 'Learn how to read QC photos, spot flaws and approve or reject items before they ship.',
  'article.how_to_use': 'How to Use the AllChinaBuy Spreadsheet',
  'article.how_to_use_desc': 'A step-by-step walkthrough of the spreadsheet interface, from browsing categories to placing your first order.',
  'article.seller_guide': 'AllChinaBuy Seller Guide: Finding Trusted Sellers',
  'article.seller_guide_desc': 'How to evaluate seller reputation, reviews, and communication before you buy.',
  'article.beginner_guide': 'AllChinaBuy Beginner Guide: Start with Confidence',
  'article.beginner_guide_desc': 'A complete introduction for first-time buyers covering accounts, orders, QC and shipping.',
  'article.best_finds': 'Best AllChinaBuy Finds: Top Products Worth Buying',
  'article.best_finds_desc': 'Our curated picks of trending shoes, clothing, bags and accessories worth checking out.',
  'article.warehouse': 'AllChinaBuy Warehouse Guide: Storage, QC & Shipping',
  'article.warehouse_desc': 'Understand how the warehouse stores, inspects and consolidates your orders before shipping.',
  'article.alternatives': 'AllChinaBuy Alternatives: Platforms Compared',
  'article.alternatives_desc': 'A balanced comparison of AllChinaBuy and other shopping agent platforms.',
  'article.payment': 'AllChinaBuy Payment & Refund Guide',
  'article.payment_desc': 'Payment methods, refund policies and how to resolve issues with your orders.',
  'article.tracking': 'AllChinaBuy Tracking Guide: Follow Your Order',
  'article.tracking_desc': 'How to track your package from warehouse to doorstep with useful tips.',
  'article.qc_checklist': 'AllChinaBuy QC Checklist: Verify Before Shipping',
  'article.qc_checklist_desc': 'A printable checklist of what to check in QC photos before approving shipment.',
  'article.best_sellers': 'Best AllChinaBuy Sellers 2026: Trusted Shops',
  'article.best_sellers_desc': 'The sellers with the strongest reputation across popular product categories.',

  // Trust section
  'trust.title': 'Is AllChinaBuy Safe to Use?',
  'trust.subtitle': 'Our independent safety assessment',
  'trust.desc': 'We have analyzed the AllChinaBuy platform independently. This site is not affiliated with AllChinaBuy. We provide honest, research-based information to help you make informed decisions.',
  'trust.checklist_title': 'Safety Checklist Before Buying',
  'trust.check_1': 'Verify seller reputation and reviews',
  'trust.check_2': 'Check QC photos before approving shipment',
  'trust.check_3': 'Use secure payment methods',
  'trust.check_4': 'Compare shipping costs and methods',
  'trust.check_5': 'Read recent buyer experiences',
  'trust.read_more': 'Read Full Safety Guide',

  // FAQ
  'faq.title': 'Frequently Asked Questions',
  'faq.q1': 'What is the AllChinaBuy Spreadsheet?',
  'faq.a1': 'The AllChinaBuy Spreadsheet is a curated collection of product links, seller information, and buying resources that helps shoppers find quality products through the AllChinaBuy platform. It organizes products by category with links, prices, and seller ratings.',
  'faq.q2': 'How do I use the AllChinaBuy Spreadsheet?',
  'faq.a2': 'Simply browse the categories that interest you, click on product links to view details on the AllChinaBuy platform, and follow the buying guides for a smooth purchasing experience. We recommend starting with our Complete Guide for beginners.',
  'faq.q3': 'Is AllChinaBuy legit?',
  'faq.a3': 'AllChinaBuy is a known shopping agent platform. Like any online marketplace, buyer experiences vary. We recommend reading our independent safety guide, checking seller reviews, and always using QC photos before approving shipments.',
  'faq.q4': 'How much does AllChinaBuy shipping cost?',
  'faq.a4': 'Shipping costs vary by destination, weight, and shipping method. Our shipping cost guide provides detailed estimates for USA, UK, Germany, France, Denmark and other countries.',
  'faq.q5': 'Does AllChinaBuy have coupons?',
  'faq.a5': 'AllChinaBuy occasionally offers coupons and discount codes. Check our coupon guide for the latest offers and tips on maximizing your savings.',

  // Footer
  'footer.about_title': 'About This Site',
  'footer.about_desc': 'AllChinaBuySpread is an independent resource hub. We are not officially affiliated with AllChinaBuy. All information is for research and educational purposes only.',
  'footer.links_title': 'Quick Links',
  'footer.link_safety': 'Safety Guide',
  'footer.link_about': 'About Us',
  'footer.link_contact': 'Contact',
  'footer.link_disclaimer': 'Disclaimer',
  'footer.legal': 'This is an independent resource website. Product links redirect to AllChinaBuy and kaspreadsheet.com.',
  'footer.copyright': '© 2026 AllChinaBuySpread. All rights reserved.',

  // Common
  'common.loading': 'Loading...',
  'common.read_time': 'min read',
  'common.updated': 'Updated',
  'common.independent': 'Independent Resource',
};